// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"351":"commons","532":"styles","678":"component---src-pages-index-js","851":"component---src-templates-post-js"}[chunkId] + "-" + {"351":"9744a2940f492d4f2adb","532":"7d352f91b64aae943da8","678":"107b3a0928c93a11b071","851":"de9cb278dc4ef7bb9b2c"}[chunkId] + ".js";
};